import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/pages/login'
import register from '@/components/pages/register'
import accountSet from '@/components/pages/accountSet'
import forgetPwd from '@/components/pages/forgetPwd'
import index from '@/components/pages/index'
import applyPage from '@/components/pages/applyPage'
import classStatus from '@/components/pages/classStatus'
import pay from '@/components/pages/pay'   //二维码支付
import success from '@/components/pages/success'   //支付成功
import choosePayWay from '@/components/pages/choosePayWay'   //选择支付方式

import personal from '@/components/pages/personal'   //个人中心
import orderList from '@/components/pages/orderList'   //个人中心
import count from '@/components/pages/count'   //个人中心
import payOrderList from '@/components/pages/payOrderList'   //订单中心

// 后台管理
import root from '@/components/pages/rootPage/layout/root'
import levelScore from '@/components/pages/rootPage/levelScore'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login,
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },{
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/forgetPwd',
      name: 'forgetPwd',
      component: forgetPwd
    },
    {
      path: '/index',
      name: 'index',
      component: index,
      children:[
        {
          path: 'applyPage',
          name: 'applyPage',
          component: applyPage,
        },
        {
          path: 'classStatus',
          name: 'classStatus',
          component: classStatus,
        },{
          path: 'choosePayWay',
          name: 'choosePayWay',
          component: choosePayWay,
        },{
          path: 'pay',
          name: 'pay',
          component: pay,
        },
        {
          path: 'accountSet',
          name: 'accountSet',
          component: accountSet
        },
        {
          path: 'success',
          name: 'success',
          component: success,
        },{
          path: 'personal',
          name: 'personal',
          component: personal,
          children:[
            {path:'orderList',name:'orderList',component:orderList,
              meta:{
                'second':'orderList'
              }
            },
            {path:'count',name:'count',component:count,
              meta:{
                'second':'count'
              }
            },
            {path:'payOrderList',name:'payOrderList',component:payOrderList,
              meta:{
                'second':'payOrderList'
              }
            },
          ]
        }
      ]
    },
    {
      path: '/root',
      name: 'root',
      component: root,
      children:[
        {
          path: 'levelScore',
          name: 'levelScore',
          component: levelScore,
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js